import React from "react";
import "./incidentes.css";

const ImageViewerCard = ({ imagenUrl, titulo }) => {
  return (
    <div className="imgpro-wrap">
      <div className="imgpro-card">
        {titulo && <div className="imgpro-title">{titulo}</div>}

        <div className="imgpro-body">
          <img
            className="imgpro-image"
            src={imagenUrl}
            alt={titulo || "Imagen del proceso"}
            draggable={false}
            onContextMenu={(e) => e.preventDefault()}
          />
        </div>
      </div>
    </div>
  );
};

export default ImageViewerCard;
